
import * as React from 'react';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { DataGrid } from '@process-advisor/process-miner/modals/detail/dataGrid';
import { eventSummaryGridColumns1 } from '@process-advisor/process-miner/modals/detail/eventDetail/eventSummaryGridColumns1';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'

type Row = {};

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let attribute = '';

let optionsAttributes = [];

export const EventSummaryGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);
    const [columns, setColumns] = React.useState<ColDef[]>();

    React.useEffect(() => {

        setColumns(eventSummaryGridColumns1())
    
    }, []);


    React.useEffect(() => {
        const listener = () => {
            apiProvider.setEventDetailExtract({type: 'summary'})
            setData(apiProvider.processDetailEventSummary());
        }
        listener();

        apiProvider.on(Event.openEventDetailModal, listener);

        return () => {
            apiProvider.off(Event.openEventDetailModal, listener);
        };
    }, []);

    React.useEffect(() => {
        eventAttributes();
        const temp = apiProvider.getDetailEventSummaryAttribute()
        if (temp['attribute'] != '') {
            attribute = temp['attribute']
        }
        apiProvider.setEventDetailExtract({type: 'summary'})
        setData(apiProvider.processDetailEventSummary());
    }, []);

    const onAttributeChange = (attributeSelected: string) => {
        attribute = attributeSelected;
        apiProvider.changeDetailEventSummaryAttribute({ attribute });
        setData(apiProvider.processDetailEventSummary());
    };

    const eventAttributes = () => {
        optionsAttributes = [];
        const tOptions = apiProvider.eventAttributes({});
        for (const each of tOptions) {
            const valueToPush = { value: each.value, label: each.label };
            optionsAttributes.push(valueToPush);
        }
        if (optionsAttributes.length > 0 ) {
            attribute = optionsAttributes[0].value;
        }
    };

    const rows = data.map((row, id) => ({ id, ...row }));
    
    return (
        <Wrapper>
            <SingleBlock width="10%">
                <Section title='Group by:'/>
            </SingleBlock>
            <SingleBlock width="90%">
                <Dropdown
                    options={optionsAttributes}
                    onChange={onAttributeChange}
                    value={attribute}/>
            </SingleBlock>
            <DataGrid
                rows={rows}
                columns={columns}
                type={'summary'}
                height="550px" />

        </Wrapper>
    );
};
